import { Component, ViewChild } from '@angular/core';
import {
  DATA_SERVICE_TOKEN,
  EoSearchPageComponent,
  SearchPageOptionsService,
  STATUS,
} from 'ngx-eo-web-components';
import { Surgery } from '../../../core/models/surgery.model';
// import { citizenSurgerySearchFormConfig } from '../../config/surgeries-citizen-search-form.config';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CitizenSurgeriesTableConfigBuilder } from '../../config/surgeries-citizen-search.config';
import { AuthService } from '../../../../services/auth/auth.service';
import { SurgeryCitizenService } from '../../../../services/surgery/surgery.citizen.service';
import { Router } from '@angular/router';
import { CoreService } from '../../../core/core.service';

@Component({
  selector: 'app-surgeries-citizen-list',
  templateUrl: './surgeries-citizen-list.component.html',
  styleUrl: './surgeries-citizen-list.component.scss',
  providers: [
    SearchPageOptionsService,
    { provide: DATA_SERVICE_TOKEN, useClass: SurgeryCitizenService },
  ],
})
export class SurgeriesCitizenListComponent extends EoSearchPageComponent<Surgery> {

  hospitalId?: string | null;

  data$ = new BehaviorSubject<Surgery[]>([]);
  token$ = this.authService.token$;
  tokenData = this.token$.getValue();

  override tableConfig = this.getSurgeryTableConfig();

  protected getSurgeryTableConfig() {
    let data = this.searchService.searchCh.data$.getValue()?.resultset ?? [];

    return new CitizenSurgeriesTableConfigBuilder()
      .addIdikaSurgeryOperationsEllipsisFunction(
        this.idikaSurgeryOperationsFullText.bind(this)
      )
      .addSurgeryStatusNameFunction(this.surgeryStatusNameCheck.bind(this))
      // .addCancelSurgeryFunction(this.cancelSurgery.bind(this))
      .addIsCancelSurgeryBtnVisibleFunction(
        this.isCancelSurgeryBtnVisible.bind(this)
      )
      .addCancelSurgeryFuncion(this.cancelSurgery.bind(this))
      .addViewSurgeryFunction(this.viewSurgery.bind(this))
      .addSearchAvailabilityFunction(
        this.navigateToSearchAvailabilityForm.bind(this)
      )
      .getTable(data);
  }

  //override formConfig = citizenSurgerySearchFormConfig;

  constructor(
    override searchService: SurgeryCitizenService,
    private authService: AuthService,
    private surgeryCitizenService: SurgeryCitizenService,
    private coreService: CoreService,
    private router: Router
  ) {
    super(searchService);
  }

  private idikaSurgeryOperationsFullText(surgery?: Surgery): string {
    return this.getIdikaSurgeryOperationsFullText(surgery);
  }

  isToolTipVisible(): boolean {
    return this.authService.hasRoles(['!ClinicAdmin']);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.searchService.searchCh.data$.subscribe(() => {
      if (this.tableConfig) {
        this.tableConfig = this.getSurgeryTableConfig();
      }
    });
  }

  onSearch() {
    this.searchParam = { PatientAmka: this.tokenData?.amka ?? '12084000319' };

    //console.log("searchParam::", this.searchParam);
    this.searchService
      .searchCitizenSurgeries(
        this.searchParam,
        this.getPagesize(),
        this.getPage()
      )
      .subscribe();
  }

  override getTotalCount(): number {
    return this.searchService.searchCh.data$.getValue()?.totalCount ?? 0;
  }

  onTriggerSearch() {
    this.onSearch();
  }

  getIdikaSurgeryOperationsFullText(surgery?: Surgery): string {
    return surgery?.idikaSurgeryOperations ?? '';
  }

  private surgeryStatusNameCheck(surgery?: Surgery): string {
    return surgery?.surgeryStatusAlias == 'canceled'
      ? this.getCanceledTooltipHtml(surgery)
      : '';
  }

  private viewSurgery(surgery?: Surgery, $event?: any): void {
    if (surgery?.id) {
      this.router.navigate(['surgery/view', surgery?.id]);
    }
  }
  
  private isCancelSurgeryBtnVisible(surgery?: Surgery): boolean {
    const statusAlias = surgery?.surgeryStatusAlias.toLowerCase();
    return (
      // !this.isPrivateHospital() &&
      (statusAlias === 'scheduled' )
    );
  }

  private navigateToSearchAvailabilityForm(
    surgery?: Surgery,
    $event?: any
  ): void {
    if (surgery?.id) {
      this.router.navigate(['surgery/privateavailability', surgery?.id]);
    }
  }

  getCanceledTooltipHtml(surgery: Surgery): string {
    return `<strong>Αιτιολογία</strong>: ${
      surgery?.cancelReason
    }<br/><strong>Σχόλιο</strong>: ${surgery?.cancelComments ?? '-'}`;
  }
 
  private cancelSurgery(surgery?: Surgery, $event?: any): void {
    this.confirmationService.confirm({
      target: $event.target,
      header: 'ΠΡΟΣΟΧΗ!',
      message: 'Προσοχή! Είστε βέβαιοι ότι θέλετε να ακυρώσετε τον προγραμματισμό του συγκεκριμένου χειρουργείου; Με την ακύρωση, το χειρουργείο θα μεταφερθεί σε κατάσταση «Προς Ιδιωτική Δομή».',
      rejectLabel: 'Όχι',
      closeOnEscape: false,
      icon: 'pi pi-exclamation-triangle p-warning',
      acceptLabel: 'Ναι',
      rejectVisible: true,
      rejectButtonStyleClass: 'p-button-text',
      key: 'surgeryCitizenCancelPopup',
      accept: () => {
         this.surgeryCitizenService
          .changePrivateHospitalByCitizen(surgery?.id ?? '')
          .subscribe(() => this.onGenericActionSuccess());
      },
    });
  }
  private onGenericActionSuccess() {
    this.showGenericActionMessage();
    this.onSearch();
  }

  showGenericActionMessage(): void {
    this.coreService.showSuccess('Η ενέργεια ολοκληρώθηκε με επιτυχία!');
  }
  override isLoading(){
    return super.isLoading() || this.surgeryCitizenService.changeSurgeryPrivateHospitalCallHandler.status$.getValue() === STATUS.loading;
  }
  
}
